import { Component } from '../../common/component';
import { URL } from '../../../integrations/url/url';
import { CheerfyPaySocket } from '../../../integrations/sockets/cheerfypay/cheerfy-pay-socket';
import { SocketActions } from '../../../shared/enums/integrations/socket/socket-actions.enum';
import { SocketResponse } from '../../../shared/types/integrations/sockets/socket-response.type';
import { UpdateOrderResponse } from '../../../shared/types/integrations/sockets/cheerfy-socket.type';
import { Locale } from '../../../integrations/locale/locale';
import { Currency } from '../../../integrations/locale/currency/currency';

export class FormComponent extends Component {
    public static isProd(): boolean {
        return FormComponent.getVariable('isProd').toString() === 'true';
    }

    public static getCurrency(): string {
        return FormComponent.getVariable('currency')
            || URL.getQueryParams<{ currency: string }>()?.currency || '';
    }

    public static getDueAmount(): number {
        return Number(FormComponent.getVariable('total')) || 0;
    }

    public static getVariable(variable: string): string {
        const input = $(`[name="${variable}"]`);

        const value = input.val()
            ?.toString();

        if (value === undefined) {
            return '';
        }

        return value;
    }

    public static setVariable(variable: string, value: string | number): void {
        const input = $(`[name="${variable}"]`);

        input.val(value);
    }

    private readonly _validator: any;

    private readonly _extraValidations: (() => boolean)[] = [];

    private readonly _socket?: CheerfyPaySocket;

    public constructor(container: JQuery, socket?: CheerfyPaySocket) {
        super(container);

        this._validator = container.validate({
            ignore: ':hidden, .no-validate, .adyen-checkout__input',
        });

        this._socket = socket;

        this._addEventListeners();
        this._addSocketListeners();
    }

    public get valid() {
        return this._validator.valid() && this._extraValidations.every((fn) => fn());
    }

    private get submitButton() {
        return this.container.find('.submit-btn');
    }

    public setAmountText(amount: number) {
        if (amount === 0) {
            this.submitButton.text(
                Locale.getTrans('payment.pay', 'pay').toString(),
            );

            return;
        }

        const currencyAmount = Currency.toLocaleCurrency(amount / 100, FormComponent.getCurrency());

        this.submitButton.text(
            Locale.getTrans('payment.pay_now', 'pay_now', currencyAmount).toString(),
        );
    }

    public setDefaultStyles() {
        this.submitButton.get(0).className = 'pay-button submit-btn';
    }

    public setApplePayStyles() {
        this.submitButton.get(0).className = 'pay-button submit-btn pay-button--third-party pay-button--apple-pay';
    }

    public setGPayStyles() {
        this.submitButton.get(0).className = 'pay-button submit-btn pay-button--third-party pay-button--gpay';
    }

    public showLoading() {
        this.container.find('.pay-button--processing-wrapper')
            .removeClass('hide');

        this.submitButton.hide();
    }

    public hideLoading() {
        this.container.find('.pay-button--processing-wrapper')
            .addClass('hide');

        this.submitButton.show();
    }

    public registerValidation(fn: () => boolean) {
        this._extraValidations.push(fn);
    }

    public submit() {
        this.submitButton.get(0).click();
    }

    public syncInputs(data: Object) {
        for (const [key, value] of Object.entries(data ?? {})) {
            this.container.find(`[name=${key}]`)
                .val(value);
        }
    }

    public disableButtons() {
        this._container.find('button, input[type=button], input[type=submit]')
            .attr('disabled', 'true');
    }

    public enableButtons() {
        this._container.find('button, input[type=button], input[type=submit]')
            .removeAttr('disabled');
    }

    protected _addEventListeners() {
        this._container.on('submit', this._onFormSubmit.bind(this));

        this._container.on('keydown', (event) => event.key !== 'Enter');
    }

    protected _addSocketListeners() {
        if (this._socket === undefined) return;

        this._socket.on(`message::${SocketActions.UPDATE_ORDER}`, this._onSocketUpdateOrder.bind(this));
    }

    protected _onFormSubmit(event: Event) {
        event.preventDefault();

        this.dispatch('submit');
    }

    private _onSocketUpdateOrder({ order }: SocketResponse<UpdateOrderResponse>) {
        FormComponent.setVariable('total', order.ticket_summary.total);
    }
}
